import React from 'react';
import { Box, Container, useTheme } from '@mui/material';

export type PageBackgroundType = 'default' | 'stripe' | 'gradient' | 'none';

interface PageContainerProps {
  children: React.ReactNode;
  background?: PageBackgroundType;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  py?: number | { xs?: number; sm?: number; md?: number };
  px?: number | { xs?: number; sm?: number; md?: number };
  className?: string;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  background = 'default',
  fullWidth = false,
  maxWidth = 'lg',
  py = 3,
  px,
  className,
}) => {
  const theme = useTheme();

  // Get background styles based on the background type
  const getBackgroundStyles = () => {
    switch (background) {
      case 'gradient':
        return {
          background: theme.palette.gradients?.page || 'linear-gradient(180deg, rgba(246,249,254,1) 0%, rgba(238,244,254,1) 100%)',
        };
      case 'none':
        return {};
      case 'default':
      default:
        return {
          background: theme.palette.background.default,
        };
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        ...getBackgroundStyles(),
        ...(className ? { className } : {}),
      }}
    >
      {fullWidth ? (
        <Box sx={{ py, px, position: 'relative', zIndex: 1 }}>
          {children}
        </Box>
      ) : (
        <Container maxWidth={maxWidth} sx={{ py, px, position: 'relative', zIndex: 1 }}>
          {children}
        </Container>
      )}
    </Box>
  );
}; 